export default {
    firstDay: {
        AD: "1",
        ad: "1",
        AE: "6",
        ae: "6",
        AF: "6",
        af: "6",
        AG: "0",
        ag: "0",
        AI: "1",
        ai: "1",
        AL: "1",
        al: "1",
        AM: "1",
        am: "1",
        AN: "1",
        an: "1",
        AR: "0",
        ar: "0",
        AS: "0",
        as: "0",
        AT: "1",
        at: "1",
        AU: "0",
        au: "0",
        AX: "1",
        ax: "1",
        AZ: "1",
        az: "1",
        BA: "1",
        ba: "1",
        BD: "0",
        bd: "0",
        BE: "1",
        be: "1",
        BG: "1",
        bg: "1",
        BH: "6",
        bh: "6",
        BM: "1",
        bm: "1",
        BN: "1",
        bn: "1",
        BR: "0",
        br: "0",
        BS: "0",
        bs: "0",
        BT: "0",
        bt: "0",
        BW: "0",
        bw: "0",
        BY: "1",
        by: "1",
        BZ: "0",
        bz: "0",
        CA: "0",
        ca: "0",
        CH: "1",
        ch: "1",
        CL: "1",
        cl: "1",
        CM: "1",
        cm: "1",
        CN: "0",
        cn: "0",
        CO: "0",
        co: "0",
        CR: "1",
        cr: "1",
        CY: "1",
        cy: "1",
        CZ: "1",
        cz: "1",
        DE: "1",
        de: "1",
        DJ: "6",
        dj: "6",
        DK: "1",
        dk: "1",
        DM: "0",
        dm: "0",
        DO: "0",
        do: "0",
        DZ: "6",
        dz: "6",
        EC: "1",
        ec: "1",
        EE: "1",
        ee: "1",
        EG: "6",
        eg: "6",
        ES: "1",
        es: "1",
        ET: "0",
        et: "0",
        FI: "1",
        fi: "1",
        FJ: "1",
        fj: "1",
        FO: "1",
        fo: "1",
        FR: "1",
        fr: "1",
        GB: "1",
        gb: "1",
        GE: "1",
        ge: "1",
        GF: "1",
        gf: "1",
        GP: "1",
        gp: "1",
        GR: "1",
        gr: "1",
        GT: "0",
        gt: "0",
        GU: "0",
        gu: "0",
        HK: "0",
        hk: "0",
        HN: "0",
        hn: "0",
        HR: "1",
        hr: "1",
        HU: "1",
        hu: "1",
        ID: "0",
        id: "0",
        IE: "0",
        ie: "0",
        IL: "0",
        il: "0",
        IN: "0",
        in: "0",
        IQ: "6",
        iq: "6",
        IR: "6",
        ir: "6",
        IS: "1",
        is: "1",
        IT: "1",
        it: "1",
        JM: "0",
        jm: "0",
        JO: "6",
        jo: "6",
        JP: "0",
        jp: "0",
        KE: "0",
        ke: "0",
        KG: "1",
        kg: "1",
        KH: "0",
        kh: "0",
        KR: "0",
        kr: "0",
        KW: "6",
        kw: "6",
        KZ: "1",
        kz: "1",
        LA: "0",
        la: "0",
        LB: "1",
        lb: "1",
        LI: "1",
        li: "1",
        LK: "1",
        lk: "1",
        LT: "1",
        lt: "1",
        LU: "1",
        lu: "1",
        LV: "1",
        lv: "1",
        LY: "6",
        ly: "6",
        MA: "6",
        ma: "6",
        MC: "1",
        mc: "1",
        MD: "1",
        md: "1",
        ME: "1",
        me: "1",
        MH: "0",
        mh: "0",
        MK: "1",
        mk: "1",
        MM: "0",
        mm: "0",
        MN: "1",
        mn: "1",
        MO: "0",
        mo: "0",
        MQ: "1",
        mq: "1",
        MT: "0",
        mt: "0",
        MV: "5",
        mv: "5",
        MX: "0",
        mx: "0",
        MY: "1",
        my: "1",
        MZ: "0",
        mz: "0",
        NI: "0",
        ni: "0",
        NL: "1",
        nl: "1",
        NO: "1",
        no: "1",
        NP: "0",
        np: "0",
        NZ: "1",
        nz: "1",
        OM: "6",
        om: "6",
        PA: "0",
        pa: "0",
        PE: "0",
        pe: "0",
        PH: "0",
        ph: "0",
        PK: "0",
        pk: "0",
        PL: "1",
        pl: "1",
        PR: "0",
        pr: "0",
        PT: "1",
        pt: "1",
        PY: "0",
        py: "0",
        QA: "6",
        qa: "6",
        RE: "1",
        re: "1",
        RO: "1",
        ro: "1",
        RS: "1",
        rs: "1",
        RU: "1",
        ru: "1",
        SA: "0",
        sa: "0",
        SD: "6",
        sd: "6",
        SE: "1",
        se: "1",
        SG: "0",
        sg: "0",
        SI: "1",
        si: "1",
        SK: "1",
        sk: "1",
        SM: "1",
        sm: "1",
        SV: "0",
        sv: "0",
        SY: "6",
        sy: "6",
        TH: "0",
        th: "0",
        TJ: "1",
        tj: "1",
        TM: "1",
        tm: "1",
        TN: "0",
        tn: "0",
        TR: "1",
        tr: "1",
        TT: "0",
        tt: "0",
        TW: "0",
        tw: "0",
        UA: "1",
        ua: "1",
        UM: "0",
        um: "0",
        US: "0",
        us: "0",
        UY: "1",
        uy: "1",
        UZ: "1",
        uz: "1",
        VA: "1",
        va: "1",
        VE: "0",
        ve: "0",
        VI: "0",
        vi: "0",
        VN: "1",
        vn: "1",
        WS: "0",
        ws: "0",
        XK: "1",
        xk: "1",
        YE: "0",
        ye: "0",
        ZA: "0",
        za: "0",
        ZW: "0",
        zw: "0"
    }
};
